import { App } from '../work-modules/049/App';

export const main = async () => {
  // WebGPUの可用性チェック
  if (!navigator.gpu) {
    const canvas = document.getElementById('webgl-canvas') as HTMLCanvasElement;
    if (canvas) {
      // キャンバスを非表示にして、代わりにメッセージを表示
      canvas.style.display = 'none';

      // エラーメッセージを表示する要素を作成
      const errorMessage = document.createElement('div');
      errorMessage.textContent = 'このページはWebGPU対応ブラウザのみ閲覧可能です';
      errorMessage.style.cssText = `
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100vh;
        font-size: 1.5rem;
        color: #fff;
        background-color: #111;
        text-align: center;
        padding: 2rem;
      `;

      // キャンバスの親要素にメッセージを追加
      const canvasWrapper = canvas.parentElement;
      if (canvasWrapper) {
        canvasWrapper.appendChild(errorMessage);
      }
    }
    return;
  }

  const canvas = document.getElementById('webgl-canvas') as HTMLCanvasElement;
  if (canvas) {
    const app = new App(canvas);
    await app.initialize();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  main();
});
